import { render, staticRenderFns } from "./ActionWhy.vue?vue&type=template&id=01813ff5&scoped=true"
import script from "./ActionWhy.vue?vue&type=script&lang=js"
export * from "./ActionWhy.vue?vue&type=script&lang=js"
import style0 from "./ActionWhy.vue?vue&type=style&index=0&id=01813ff5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01813ff5",
  null
  
)

export default component.exports